import type { LocalModelServer } from "./types";

// deepcontext-7px2.4 — the per-job local-model picker is visible to one
// user only, and never while an admin is impersonating them (an impersonation
// session carries the target's email). The backend enforces the same rule.
const LOCAL_MODEL_ALLOWED_EMAIL = "marko.dupor@eskimi.com";

export const isLocalModelAllowed = (
  user: { email?: string | null } | null | undefined,
  impersonation: unknown,
): boolean =>
  impersonation == null &&
  (user?.email ?? "").toLowerCase() === LOCAL_MODEL_ALLOWED_EMAIL;

// deepcontext-63k8.3 — display text for a job's server: its configured label,
// or the raw id flagged when that server is no longer configured.
export const describeLocalModel = (
  id: string,
  servers: LocalModelServer[],
): { text: string; configured: boolean } => {
  const server = servers.find((s) => s.id === id);
  return server
    ? { text: server.label, configured: true }
    : { text: `${id} (not configured)`, configured: false };
};
